"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
var react_router_1 = require("react-router");
var is_node_1 = require("@reverbdotcom/commons/dist/is-node");
var curated_set_row_actions_1 = require("../components/discovery/actions/curated_set_row_actions");
var collection_header_store_1 = require("../components/discovery/stores/collection_header_store");
var route_params_1 = require("../components/helpers/route_params");
var LandingPageRoute = (React.createElement(react_router_1.Route, { key: "gear/:landing_page_slug", path: "gear/:landing_page_slug", getComponent: function (location, cb) {
        require.ensure([], function (require) {
            cb(null, require('../components/discovery/default_grid').default);
        }, 'marketplace');
    }, onChange: function (oldState, nextState) {
        curated_set_row_actions_1.default.fetch(route_params_1.default(nextState));
        if (!lodash_1.isEqual(oldState.params, nextState.params)) {
            collection_header_store_1.CollectionHeaderActions.fetchOrClear(nextState.params);
        }
    }, onEnter: function (nextState) {
        if (is_node_1.default) {
            return;
        }
        collection_header_store_1.CollectionHeaderActions.fetchOrClear(nextState.params);
        curated_set_row_actions_1.default.fetch(route_params_1.default(nextState));
    } }));
exports.default = LandingPageRoute;
//# sourceMappingURL=landing_page.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/routes/landing_page.js
// module id = dmSx
// module chunks = 20 21